
<div class="row">
    <div class="col-12">

        <div class="d-lg-none mobile">

            <!-- Show title w/ dropdown navigation for mobile -->
            <mat-select *ngIf="selectedNavItem" [(value)]="selectedNavItem" (selectionChange)="onSelectNavLevel($event.value)">
                <mat-option *ngFor="let nav of navItems$ | async"
                    [value]="nav">
                    {{nav.name}}
                </mat-option>
            </mat-select>
        </div>
        
        <div class="d-none d-lg-inline desktop">
        <!-- Just show title (no drop down) -->
        <h3>{{title}}</h3>
        </div>

    </div>
</div>
